var map = {
	"./0.png": 889,
	"./1.png": 944,
	"./2.png": 803,
	"./3.png": 578,
	"./4.png": 525,
	"./5.png": 636,
	"./6.png": 111,
	"./7.png": 774,
	"./8.png": 665,
	"./9.png": 840
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 86;